var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share",
    clipPath: "url(#clip0_243_1919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 52 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89462 10.545C7.63101 10.2813 7.63101 9.85396 7.89462 9.59036L14.3291 3.02012H10.8676C10.4948 3.02012 10.1926 2.71792 10.1926 2.34512C10.1926 1.97233 10.4948 1.67012 10.8676 1.67012H15.9587C16.3315 1.67012 16.6337 1.97233 16.6337 2.34512L16.6337 7.43629C16.6337 7.80909 16.3315 8.11129 15.9587 8.11129C15.5859 8.11129 15.2837 7.80908 15.2837 7.43629L15.2837 3.97472L8.84921 10.545C8.58561 10.8086 8.15822 10.8086 7.89462 10.545Z",
    fill: "#9FA6B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 192 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00039 4.2748C4.37907 4.2748 3.87539 4.77848 3.87539 5.3998V13.4998C3.87539 14.1211 4.37907 14.6248 5.00039 14.6248H13.1004C13.7217 14.6248 14.2254 14.1211 14.2254 13.4998V10.3498C14.2254 9.97701 14.5276 9.67481 14.9004 9.67481C15.2732 9.67481 15.5754 9.97701 15.5754 10.3498V13.4998C15.5754 14.8667 14.4673 15.9748 13.1004 15.9748H5.00039C3.63349 15.9748 2.52539 14.8667 2.52539 13.4998V5.3998C2.52539 4.0329 3.63349 2.9248 5.00039 2.9248H8.15039C8.52318 2.9248 8.82539 3.22701 8.82539 3.5998C8.82539 3.9726 8.52318 4.2748 8.15039 4.2748H5.00039Z",
    fill: "#9FA6B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_1919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.5acd3065fd0b879f143f50da9760a3db.svg";
export { ForwardRef as ReactComponent };